import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=fd3cd772&scoped=true&"
import script from "./Chats.vue?vue&type=script&lang=ts&"
export * from "./Chats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3cd772",
  null
  
)

export default component.exports